import styled from 'styled-components'

export const HelpTipWrapper = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
`
